var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallWhiteLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "small-white-logo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112 112"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".small-white-logo_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M62.95 16.14c-1.74-3.64-5.45-5.96-9.51-5.96h-.02-6.89L56.04 56l-9.51 45.82H53.44c4.06 0 7.77-2.33 9.51-5.96L84.21 56 62.95 16.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M88.95 58.77H31.43a2.77 2.77 0 110-5.54h57.52a2.77 2.77 0 110 5.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "small-white-logo_svg__cls-1",
    d: "M56 112C25.12 112 0 86.88 0 56S25.12 0 56 0s56 25.12 56 56-25.12 56-56 56zM56 2.87C26.7 2.87 2.87 26.7 2.87 56S26.71 109.14 56 109.14 109.13 85.3 109.13 56 85.3 2.87 56 2.87z"
  })));
}
export default SvgSmallWhiteLogo;